var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1915 15.0064V14.9961C10.9955 14.9961 10.0303 15.9848 10.0303 17.2001C10.0303 18.4153 10.9955 19.4042 12.1915 19.4042C13.3876 19.4042 14.3528 18.4154 14.3528 17.2104C14.3528 15.995 13.3771 15.0064 12.1915 15.0064Z",
    fill: "#92A7BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.375C7.37056 0.375 0.375 7.37056 0.375 16C0.375 24.6294 7.37056 31.625 16 31.625C24.6294 31.625 31.625 24.6294 31.625 16C31.625 7.37056 24.6294 0.375 16 0.375ZM21.7809 24.2444C21.7809 24.2444 20.9937 23.3688 20.4274 22.5966C23.1552 21.8241 24.1837 20.2793 24.1837 20.2793C21.3475 22.0329 18.6987 22.7076 16 22.6199C13.3013 22.7074 10.6525 22.0329 7.81663 20.2793C7.81663 20.2793 8.84475 21.8241 11.5729 22.5966C11.0064 23.369 10.2195 24.2444 10.2195 24.2444C5.53994 24.1414 3.725 21.2783 3.62 21.4019C3.62 15.0269 6.715 9.836 6.715 9.836C9.48475 7.8485 12.0657 7.76587 12.5588 7.75556L12.8736 8.05425C9.33788 9.04294 7.62775 10.5878 7.62775 10.5878C10.6623 9.12212 13.5224 8.60656 16 8.57569C18.4776 8.60694 21.3375 9.12212 24.3722 10.5878C24.3722 10.5878 22.6621 9.04294 19.1265 8.05425L19.4412 7.75556C19.9344 7.76587 22.5152 7.84825 25.285 9.836C25.285 9.836 28.3799 15.0267 28.3799 21.4019C28.275 21.2783 26.4601 24.1414 21.7809 24.2444V24.2444Z",
    fill: "#92A7BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8088 14.9961V15.0064C18.6232 15.0064 17.6475 15.9952 17.6475 17.2104C17.6475 18.4154 18.6128 19.4042 19.8088 19.4042C21.0048 19.4042 21.97 18.4154 21.97 17.2001C21.97 15.9848 21.0048 14.9961 19.8088 14.9961Z",
    fill: "#92A7BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.a55ac0c83d3fc2acffde155577b46df4.svg";
export { ForwardRef as ReactComponent };